import { getToken } from '@ctsu/loader';

export const bindLogger = (fn, ctx) => (...args) => {
  const token = getToken();
  const { logError } = ctx;

  const captureError = function New(error) {
    return logError(ctx, 'An Error Occured in Protocol Application', error, null);
  };

  const { ...loggerInfo } = { logError, captureError };

  const boundLogger = function New(input) {
    return fn(token, loggerInfo, ...input);
  };

  return boundLogger(args);
};
